module.exports = __webpack_public_path__ + "static/img/dashboard.589f3d94.png";